export default __webpack_public_path__ + "static/media/mab.d609940f.png";